import React from "react";

import getIcon from "src/common/components/icons/technologies";

import { getServiceIcon } from "./helper";
import { InnerContent, Logo, Wrapper, Composition } from "./ServiceIcon.style";

export type ServiceIconProps = {
  service?: any;
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  color?: string;
  opacity?: number;
  fallback?: string;
  iconName?: string;
  alt?: string;
  title?: string;
  returnPureIcon?: boolean;
};

const ServiceIcon = (props: ServiceIconProps) => {
  const {
    x = 0,
    y = 0,
    width = 24,
    height = 24,
    color,
    opacity,
    service,
    alt,
    title,
    returnPureIcon = false
  } = props;
  const {
    iconName,
    isComposible,
    mainStackName: mainRuntimeName
  } = getServiceIcon(service, props.iconName);
  const src = `data:image/svg+xml;base64,${window.btoa(
    getIcon(props.iconName || iconName, x, y, width, height, color)
  )}`;
  let composition;
  if (isComposible) {
    const data = `data:image/svg+xml;base64,${window.btoa(
      getIcon(mainRuntimeName, x, y, width, height, "monochrome")
    )}`;
    composition = <Logo src={data} opacity={opacity} width={14} height={14} />;
  }

  if (returnPureIcon) {
    return (
      <Logo
        alt={alt}
        title={title}
        src={src}
        opacity={opacity}
        width={width}
        height={height}
      />
    );
  }

  return (
    <Wrapper className="service-icon-wrapper">
      <InnerContent>
        <Logo
          alt={alt}
          title={title}
          src={src}
          opacity={opacity}
          width={18}
          height={18}
        />
        {composition && <Composition>{composition}</Composition>}
      </InnerContent>
    </Wrapper>
  );
};

export default ServiceIcon;
